export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q04_a.548625a6.png";